import { Container, Row } from "reactstrap";
import { FAQTitle } from "../../../constants";
import { LatestArticlesVideosFaq } from "../../../data/miscellaneous/FAQ";
import FaqWidgets from "./FaqWidgets";
import FeaturedTutorials from "./FeaturedTutorials";
import LatestArticlesVideos from "./LatestArticlesVideos";
import QuickQuestions from "./quickQuestions";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";

const FaqContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={FAQTitle} parent={FAQTitle} />
      <Container fluid>
        <div className="faq-wrap">
          <Row>
            <FaqWidgets />
            <QuickQuestions />
            <FeaturedTutorials />
            <LatestArticlesVideos data={LatestArticlesVideosFaq} />
          </Row>
        </div>
      </Container>
    </>
  );
};
export default FaqContainer;
